



































import Component, { mixins } from 'vue-class-component';
import BaseFormMixin from '@/mixins/base-form-mixin';
import DatacollectForm1 from './datacollect-form-1.vue';
import DatacollectForm2 from './datacollect-form-2.vue';
import DatacollectForm3 from './datacollect-form-3.vue';
import DatacollectForm4 from './datacollect-form-4.vue';
import DatacollectForm5 from './datacollect-form-5.vue';
import DatacollectForm6 from './datacollect-form-6.vue';
import CategoryServices, { CategoryDto } from '@/services/category';
import DatacollectServices, { DatacollectDto } from '@/services/datacollect';
import { Watch } from 'vue-property-decorator';
import { checkCode } from '@/libs/util';
import { Mutation, namespace } from 'vuex-class';
const System = namespace('System');
@Component({
  components: { DatacollectForm1, DatacollectForm2, DatacollectForm3, DatacollectForm4, DatacollectForm5, DatacollectForm6 }
})
export default class DatacollectForm extends mixins(BaseFormMixin) {

  breadList = [{ name: '创建数据采集任务' }];
  dcSrv = new DatacollectServices();
  categorySrv = new CategoryServices();
  formData: DatacollectDto = {};
  loading: boolean = false;
  id: any = 0;
  templateId: any = 0;
  categoryId: any = 0;
  taskFlowId: any = 0;
  taskNodeId: any = '';
  parentJobCode: any = '';
  keepalive: boolean = true;

  initFormData() {
    this.formData = {
      collectCategoryId: this.categoryId,
      taskFlowId: this.taskFlowId,
      taskNodeId: this.taskNodeId,
      parentJobCode: this.parentJobCode,
      sourceDsColumns: [],
      sinkDsColumns: [],
      syncConfig: [],
      batchJobInfo: {
        // 采集方式 0-增量,1-全量
        jobMode: 0,
        // 清理方式 0-写入前保留,1-写入前清理
        cleanMode: 0,
        // 调度方式  0-周期性调度,1-一次性调度
        triggerMode: 0,
        day: 1,
        weekday: '1',
        season: 0,
        failRetryCount: 3,
        failTimeout: 5,
        cronExpression: '0 0 2 * * ?',
        parallelism: 1,
      },
      tunnelInfo: {
        pollingInterval: 5000,
        startupMode: 'group-offsets',
        startupOffset: '',
        startupTimestamp: 0,
        parallelism: 1,
      },
      status: 0,
      templateFlag: 0,
    };
    this.current = 0;
  }

  created() {
    this.id = this.$route.query.id;
    this.categoryId = this.$route.query.categoryId;
    this.taskFlowId = this.$route.query.taskFlowId;
    this.taskNodeId = this.$route.query.taskNodeId;
    this.parentJobCode = this.$route.query.parentJobCode;
    this.templateId = this.$route.query.templateId;
    this.initFormData();
  }

  activated() {
    this.onIdChange();
  }

  refreshKeepalive() {
    if (!this.$route.query.keepalive) {
      this.keepalive = false;
      this.$router.push({
        query: { ...this.$route.query, keepalive: 'true' }
      });
    } else {
      this.keepalive = true;
    }
  }

  @Watch('$route')
  onRouteChange(to: any, from: any) {
    this.id = this.$route.query.id;
    this.categoryId = this.$route.query.categoryId;
    this.taskFlowId = this.$route.query.taskFlowId;
    this.taskNodeId = this.$route.query.taskNodeId;
    this.parentJobCode = this.$route.query.parentJobCode;
    this.templateId = this.$route.query.templateId;
    this.cache = this.isNeedCache(from, to);
    this.onIdChange();
  }

  @Watch('id')
  async onIdChange() {
    debugger
    this.id = this.$route.query.id;
    let path = this.$route.path;

    if (path == '/data/datacollect/add') {
      this.refreshKeepalive();
      if (this.keepalive && this.cache) return false;
      if (this.templateId) {
        let res = await this.dcSrv.getInfo(this.templateId);
        if (res) {
          this.formData = res;
          this.formData.collectJobCode = res.collectJobCode?.substring(3);
          this.formData.parentJobCode = this.parentJobCode;
          this.formData.taskFlowId = this.taskFlowId;
          this.formData.taskNodeId = this.taskNodeId;
          delete this.formData.id;
          delete this.formData.templateFlag;
        } else {
           this.initFormData();
        }
      } else {
        this.initFormData();
      }
      let category = await this.categorySrv.getInfo(this.categoryId);
      this.breadList = [{ name: category.categoryName }, { name: '创建采集任务' }];
    }

    if (path == '/data/datacollect/edit') {
      if ((!this.id || this.id == this.formData.id) && this.cache) return false;
      this.spinning = true;
      let res = await this.dcSrv.getInfo(this.id);
      this.spinning = false;
      if (!res) return false;
      this.formData.id = this.id;
      this.formData = res;
      this.formData.parentJobCode = this.parentJobCode;
      this.formData.taskFlowId = this.taskFlowId;
      this.formData.taskNodeId = this.taskNodeId;
      this.current = 0;
      this.breadList = [{ name: res.collectCategoryName || '' }, { name: res.collectJobName || '' }, { name: '编辑采集任务' }];
    }
  }

  async next() {
    if (this.current === 0) {
      const must: { field: 'collectJobCode' | 'collectJobName'; msessage: string }[] = [
        { field: 'collectJobCode', msessage: '数据采集任务编码不能为空' },
        { field: 'collectJobName', msessage: '数据采集任务名称不能为空' }
        //{ field: 'collectJobType', msessage: '数据采集任务类型不能为空' }
      ];
      for (let val of must) {
        if (!this.formData[val.field]) {
          this.$message.error(val.msessage);
          return false;
        }
      }
      if (!checkCode(this.formData.collectJobCode)) {
        this.$message.error('编码只能包含英文字母、数字、下划线');
        return false;
      }
      if (!this.id) {
        let code = 'DC_' + this.formData.collectJobCode;
        let exist = await this.dcSrv.getList({ collectJobCode_eq: code });
        if (exist.length > 0) {
          this.$message.error(`编码[${code}]已经存在`);
          return false;
        }
      }
    }

    if (this.current === 1) {
      if (!this.formData.sourceDsTableName) {
        this.$message.error('数据源数据对象名称不能为空');
        return false;
      }
      if (!this.formData.sourceDsColumns || this.formData.sourceDsColumns.length <= 0) {
        this.$message.error('数据源数据对象字段不能为空');
        return false;
      }
    }

    if (this.current === 2) {
      if (!this.formData.sinkDsTableName) {
        this.$message.error('目标端数据对象名称不能为空');
        return false;
      }
      if (!this.formData.sinkDsColumns || this.formData.sinkDsColumns.length <= 0) {
        this.$message.error('目标端数据对象字段不能为空');
        return false;
      }
    }
    if (this.current === 4) {
      // 离线
      if (this.formData.collectJobType === 0) {
        // 作业调度
        if (this.formData.batchJobInfo && this.formData.batchJobInfo.triggerMode != 0 ) {
          if (!this.formData.batchJobInfo.runDateStr || !this.formData.batchJobInfo.runTimeStr) {
            this.$message.error('请将作业调度信息填写完整');
          }
        }
      }
      // 实时
      else if (this.formData.collectJobType === 1) {
        if (this.formData.tunnelInfo && this.formData.sourceDsType ) {
          if ( ['MySQL', 'PostgreSQL', 'SQLServer', 'Oracle'].includes(this.formData.sourceDsType)) {
            if (!this.formData.tunnelInfo.pollingInterval) {
              this.$message.error('请将实时通道设置填写完整');
            }
          } else if ( ['kafka'].includes(this.formData.sourceDsType)) {
            if (!this.formData.tunnelInfo.startupMode) {
              this.$message.error('请将实时通道设置填写完整');
            }
          }
        } 
      }
    }
    this.current++;
  }
  
  async confirm() {
    this.loading = true;
    if (this.id) {
      let res = await this.dcSrv.update(this.formData);
      if (res) {
        this.replaceUrlWithOutConfirm('/data/datacollect/detail?id=' + this.id);
        this.initFormData();
      }
    } else {
      let categoryId: number | boolean = typeof this.$route.query.categoryId === 'string' ? parseInt(this.$route.query.categoryId) : false;
      if (!categoryId) {
        this.$message.error('参数错误：没有指定目录');
        return false;
      }
      this.formData.collectCategoryId = categoryId;
      let res = await this.dcSrv.add(this.formData);
      if (res) {
        this.replaceUrlWithOutConfirm('/data/datacollect/detail?id=' + res.id);
        this.initFormData();
      }
    }
    this.loading = false;
    this.HANDLE_RELOAD_DS_MENU();
  }
  @Mutation HANDLE_RELOAD_DS_MENU: any;
  
}
